import {
  filterByPropertyValue,
  findIndexByPropertyValue,
  setPropertyValue
} from 'utilities/collection';

export function getSelectedActionIndex(actions, actionIndex) {

  const actionsLength = actions.length;
  let _actionIndex = 0;

  if (actionIndex >= actionsLength) {
    _actionIndex = actionIndex % actionsLength;
  } else if (actionIndex <= actionsLength) {
    _actionIndex = actionIndex % actionsLength;
  }

  if (_actionIndex < 0) {
    _actionIndex = actionsLength + _actionIndex;
  }

  return _actionIndex;

}

export function filterActionsByDisabledElements(actions, disabledElements) {

  const enabledActions = [];

  for (let action of actions) {

    if (disabledElements.indexOf(action.type) !== -1) {
      continue;
    }

    enabledActions.push(action);

  }

  return enabledActions;

}

export function filterFavouritePageNodesByDisabledElements(favouritePageNodes, disabledElements) {

  const enabledFavouritePageNodes = [];

  for (let favouritePageNode of favouritePageNodes) {

    if (disabledElements.indexOf(favouritePageNode.nodeType) !== -1) {
      continue;
    }

    enabledFavouritePageNodes.push(favouritePageNode);

  }

  return enabledFavouritePageNodes;

}

export function filterActionsByEnabledElements(actions, enabledElements) {

  const enabledActions = [];

  for (let action of actions) {

    if (enabledElements.indexOf(action.type) === -1) {
      continue;
    }

    enabledActions.push(action);

  }

  return enabledActions;

}

export function filterFavouritePageNodesByEnabledElements(favouritePageNodes, enabledElements) {

  const enabledFavouritePageNodes = [];

  for (let favouritePageNode of favouritePageNodes) {

    if (enabledElements.indexOf(favouritePageNode.nodeType) === -1) {
      continue;
    }

    enabledFavouritePageNodes.push(favouritePageNode);

  }

  return enabledFavouritePageNodes;

}

export function filterActionsByDisabledAndEnabledElementsParameters(actions, disabledElements, enabledElements, searchTerm) {

  let filteredActions = actions;

  if (disabledElements.length > 0) {
    filteredActions = filterActionsByDisabledElements(filteredActions, disabledElements);
  }

  if (enabledElements.length > 0) {
    filteredActions = filterActionsByEnabledElements(filteredActions, enabledElements);
  }

  return filterActions(filteredActions, searchTerm);

}

export function filterFavouritePageNodesByDisabledAndEnabledElementsParameters(favouritePageNodes, disabledElements, enabledElements, searchTerm) {

  let filteredFavouritePageNodes = favouritePageNodes;

  if (disabledElements.length > 0) {
    filteredFavouritePageNodes = filterFavouritePageNodesByDisabledElements(filteredFavouritePageNodes, disabledElements);
  }

  if (enabledElements.length > 0) {
    filteredFavouritePageNodes = filterFavouritePageNodesByEnabledElements(filteredFavouritePageNodes, enabledElements);
  }

  return filterActions(filteredFavouritePageNodes, searchTerm);

}

export function filterTemplatesBySearchTerm(templates = [], searchTerm = '') {

  return filterActions(templates, searchTerm);

}

function actionsFilter(currentValue, searchString, currentObject) {

  let matches = currentValue
    .toLowerCase()
    .includes(searchString);

  if (matches === true) {
    return true;
  }

  matches = currentObject.description.toLowerCase().includes(searchString);

  if (matches === true) {
    return true;
  }

  const keywords = currentObject.keywords || [];

  for (let keyword of keywords) {

    if (keyword.includes(searchString)) {
      return true;
    }

  }

  return false;

}

export function filterActions(actions, searchTerm) {

  if (searchTerm === '') {
    return actions;
  }

  const matchingActions = filterByPropertyValue(actions, 'label', searchTerm.toLowerCase(), actionsFilter);

  return matchingActions;

}

export function filterInvisibleActions(actions, editor) {

  const visibleActions = [];

  for (let action of actions) {

    const isVisible = action.isVisible;

    if (typeof isVisible !== 'function') {
      visibleActions.push(action);
      continue;
    }

    const visible = isVisible(editor);

    if (visible === false) {
      continue;
    }

    visibleActions.push(action);

  }

  return visibleActions;

}

export function filterInvisibleFavouritePageNodes(favouritePageNodes, actions, editor) {

  const visibleActions = [];

  for (let favouritePageNode of favouritePageNodes) {

    const actionIndex = findIndexByPropertyValue(actions, 'type', favouritePageNode.nodeType);

    if (actionIndex === -1) {
      continue;
    }

    const action = actions[actionIndex];

    const isVisible = action.isVisible;

    if (typeof isVisible !== 'function') {
      visibleActions.push(favouritePageNode);
      continue;
    }

    const visible = isVisible(editor);

    if (visible === false) {
      continue;
    }

    visibleActions.push(favouritePageNode);

  }

  return visibleActions;

}

export function createFavouritePageNodes(favouritePageNodes) {

  return setPropertyValue(favouritePageNodes, 'type', 'favouritePageNode');

}